import * as THREE from 'three';
import * as pmath from '../../../shared/src/pmath';

/** Optional ring staggering creates non-coplanar facets on a closed surface.
 * Radii and heights remain inside the authored profile's conservative bounds.
 * No random draws or browser-specific shape decisions occur in the renderer. */
export function proceduralLathe(instance:{params:number[];profile?:[number,number][];faceting?:number}) {
 const profile=instance.profile??[],segments=Math.round(instance.params[0]);
 const geometry=new THREE.LatheGeometry(profile.map(p=>new THREE.Vector2(p[0],p[1])),segments);
 if(!instance.faceting)return geometry;
 const positions=geometry.getAttribute('position'),amount=instance.faceting;
 for(let segment=0;segment<=segments;segment++)for(let ring=0;ring<profile.length;ring++){
  const [radius,y]=profile[ring],phase=(ring%2?1:-1)*amount*.45*Math.PI/segments;
  // The closing column is exactly identical to the first, including its offset.
  const angle=(segment%segments)*pmath.TWO_PI/segments+phase;
  positions.setXYZ(segment*profile.length+ring,radius*pmath.sin(angle),y,radius*pmath.cos(angle));
 }
 const faceted=geometry.toNonIndexed();geometry.dispose();faceted.computeVertexNormals();
 return faceted;
}
